// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { InboxConfig } from '../configs/InboxConfig';
import { isValidMessageHistoryType } from 'conversations-message-history/message-history/operators/isValidMessageHistoryType';
export const shouldRenderInHistory = message => isValidMessageHistoryType(message, InboxConfig);